import { EyeResultsTable } from '../../../ui';
import { logmarToSnellen } from '../../../helpers/data';
import { useEffect, useState } from 'react';

const AcuityResultsFV = ({ testData }) => {
  const [finalScore, setFinalScore] = useState(null);
  const {
    visualFieldForthValley: { results: { logmarSize, finalLogmarSize, orientationCorrect } = {} },
  } = testData;

  useEffect(() => {
    const getFinalLogmarScore = () => {
      return (finalLogmarSize * 10 - 1) * 0.1;
    };

    if (finalLogmarSize) setFinalScore(getFinalLogmarScore().toFixed(1));
    if (!orientationCorrect?.length) setFinalScore('>1.0');
    if (!finalLogmarSize && orientationCorrect?.length) setFinalScore(logmarSize?.toFixed(1));
  }, [finalLogmarSize, logmarSize, orientationCorrect]);

  return (
    <div style={{ width: '100%', maxWidth: 480 }} data-testid='neuro-acuity-results'>
      <EyeResultsTable columns={['Final logMAR score', 'Snellen']} rows={[{ tone: 'emphasis', cells: [finalScore ?? '--', logmarToSnellen[finalScore] || 'N/A'] }]} />
    </div>
  );
};

export default AcuityResultsFV;
